"use client";

import { useSnapshot } from "valtio";
import { AccountState } from "../../stores/accountStore";
export function useIsAuthenticated() {
  const {
    authenticated
  } = useSnapshot(AccountState);
  return authenticated;
}